import React from "react";
import { connect } from "react-redux";
import "./_NecklaceSelectModal.scss";
import { Header, CalculatePriceButton } from "..";
import { ReactComponent as Cross } from "../../assets/svg/cross.svg";
import {
  closeNecklaceSelectModals,
  setCalculateNecklacePrice,
} from "../../redux/actions";
import NecklaceSelectList from "../NecklaceSelectList/NecklaceSelectList";
import MemoryEditView from "../MemoryEditView/MemoryEditView";
import MemoryFilter from "../MemoryFilter/MemoryFilter";

class NecklaceSelectModal extends React.Component {
  renderSelectContainer = () => {
    const {
      modalNecklaceOpen,
      necklaceOverlayNoPriceCalcText,
      calculateNecklacePrice,
      modalShowEditMemory,
    } = this.props;
    if (modalShowEditMemory) {
      return (
        <div className="select-container">
          <MemoryEditView />
        </div>
      );
    } else {
      return (
        <div className="select-container">
          <div className="select-container-header">
            {modalNecklaceOpen ? (
              <CalculatePriceButton
                text={necklaceOverlayNoPriceCalcText}
                calculatePrice={calculateNecklacePrice}
                onPress={() =>
                  this.props.setCalculateNecklacePrice(!calculateNecklacePrice)
                }
              />
            ) : (
              <MemoryFilter />
            )}
          </div>
          <NecklaceSelectList />
        </div>
      );
    }
  };

  render() {
    const {
      modalNecklaceOpen,
      modalMemoryOpen,
      necklaceOverlayTitleText,
      memoryOverlayTitleText,
    } = this.props;
    let modalIsOpen = false;
    if (modalNecklaceOpen) {
      modalIsOpen = true;
    }
    if (modalMemoryOpen) {
      modalIsOpen = true;
    }
    const titleText = modalNecklaceOpen
      ? necklaceOverlayTitleText
      : memoryOverlayTitleText;

    const modalClass = modalIsOpen
      ? "necklace-select-modal open"
      : "necklace-select-modal";

    return (
      <div className={modalClass}>
        <Header titleText={titleText} />
        <button
          onClick={() => this.props.closeNecklaceSelectModals()}
          className="close-button"
        >
          <Cross className="close-button-icon" />
        </button>
        {this.renderSelectContainer()}
      </div>
    );
  }
}

const mapStateToProps = ({ configuratorPageNecklace, necklace }) => {
  const {
    modalNecklaceOpen,
    modalMemoryOpen,
    necklaceOverlayTitleText,
    necklaceOverlayNoPriceCalcText,
    memoryOverlayTitleText,
    memoryOverlayCollectionTitleText,
    modalShowEditMemory,
  } = configuratorPageNecklace;

  const { calculateNecklacePrice } = necklace;

  return {
    modalNecklaceOpen,
    modalMemoryOpen,
    necklaceOverlayTitleText,
    necklaceOverlayNoPriceCalcText,
    memoryOverlayTitleText,
    memoryOverlayCollectionTitleText,
    calculateNecklacePrice,
    modalShowEditMemory,
  };
};

export default connect(mapStateToProps, {
  closeNecklaceSelectModals,
  setCalculateNecklacePrice,
})(NecklaceSelectModal);
